<template>
  <li v-if="!childrenLinks && isHeader" :class="{headerLink: true, className,'mt-4' : end}">
    <router-link :to="link">
      <span class="icon">
        <i :class="fullIconName"></i>
      </span>
      <span class="sidebar-nav-list">{{header}}</span>
      <sup v-if="label" class="headerLabel">{{label}}</sup>
      <b-badge v-if="badge" class="badge rounded-f" variant="warning" pill>{{badge}}</b-badge>
    </router-link>
  </li>

  <li v-else-if="childrenLinks" :class="{headerLink: true, className,'mt-4' : end}">
    <div @click="()=>togglePanelCollapse(link)">
      <router-link :to="link" event class="d-flex">
        <span class="icon">
          <i :class="fullIconName"></i>
        </span>
        <span class="sidebar-nav-list">{{header}}</span>
        <sup v-if="label" class="headerLabel">{{label}}</sup>
        <div :class="{caretWrapper: true, carretActive: isActive}">
          <i class="fa fa-angle-right" />
        </div>
      </router-link>
    </div>
    <b-collapse :id="'collapse' + index" :visible="isActive">
      <ul>
        <NavLink
          class="child-nav"
          v-if="typeof route.meta != 'undefined' && route.meta.affix == true && $route.matched[0].path != '/settings'"
          v-for="(route,index) in childrenLinks"
          :link="'/app/'+route.path"
          :key="index"
          :isHeader="route.meta.isheader"
          :header="route.meta.title"
          :index="'/app/'+route.path"
          label
          :end="route.meta.end"
          :childrenLinks="route.childrenLinks"
        />
      </ul>
    </b-collapse>
  </li>
  <li :class="{'mt-4' : end}" v-else>
    <router-link :to="index !== 'menu' && link">
      {{header}}
      <sup v-if="label" class="headerLabel">{{label}}</sup>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NavLink",
  props: {
    badge: { type: String, dafault: "" },
    header: { type: String, default: "" },
    iconName: { type: String, default: "" },
    headerLink: { type: String, default: "" },
    link: { type: String, default: "" },
    childrenLinks: { type: Array, default: null },
    className: { type: String, default: "" },
    isHeader: { type: Boolean, default: false },
    deep: { type: Number, default: 0 },
    activeItem: { type: String, default: "" },
    label: { type: String },
    index: { type: String },
    end: { type: Boolean, default: false },
    sidebarStatic: { type: Boolean }
  },
  data() {
    return {
      headerLinkWasClicked: true
    };
  },
  methods: {
    ...mapActions("layout", ["toggleSidebar", "changeSidebarActive"]),

    async togglePanelCollapse(link) {
      await this.changeSidebarActive(link);
      if (!this.sidebarStatic) {
        await this.toggleSidebar();
      }
      this.headerLinkWasClicked =
        (await !this.headerLinkWasClicked) ||
        this.activeItem == null ||
        !this.activeItem.includes(this.index);
    }
  },
  computed: {
    fullIconName() {
      return `${this.iconName}`;
    },
    isActive() {
      return (
        this.activeItem &&
        this.activeItem.includes(this.index) &&
        this.headerLinkWasClicked
      );
    }
  }
};
</script>

<style src="./NavLink.scss" lang="scss" scoped />
